module.exports = __webpack_public_path__ + "static/media/bogota13.3c73ba2d.jpg";